import { SaveEndpoint } from 'utils/endpoint/SaveEndpoint';

type Payload = {
  codeA: string;
  spotId: string;
};

type ApiResponse = {
  codeB: string;
};

function mapPayload(payload: Payload) {
  return payload;
}

function mapResponse(response: ApiResponse) {
  return response.codeB;
}

const endpoint = new SaveEndpoint({
  urlFactory: () => '/data/website/openweb_oauth',
  mapPayload,
  mapResponse,
  method: 'post',
});

// Exports

export const apiOpenWebOauthHandshake = endpoint.createSaveFn();
